var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("Componente Hijo")]),_vm._v(" "),_c('b-field',{attrs:{"label":"Puntaje Hijo"}},[_c('b-input',{model:{value:(_vm.returnedScore),callback:function ($$v) {_vm.returnedScore=$$v},expression:"returnedScore"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }